import i18n from '@/i18n/locale';
import { trackEvent } from '@/lib/omega';
import { NewAlert } from '@didi/r-fusion-pc';
import { getLocalStorage, setLocalStorage } from '@/utils/localStorage';

const EFO_CONF = 'EFORetainConf';

export const ALERT_TYPE = {
  STRATEGY: 1, // 策略下发
  ALWAYS : 2, // 每次
}
class EfoStrategy {
  getAlert (param, cb) {
    const { 
      arrived_time = '', // 时间文案
      type = 1, // 弹窗策略
      showLogInfo, // 展示埋点信息
    } = param;
    const strategyConf = getLocalStorage(EFO_CONF) || ''; // 策略数据

    if (type === ALERT_TYPE.ALWAYS) {
      this._showAlert(arrived_time, showLogInfo, cb)
      return;
    }

    if (!strategyConf) {
      cb && cb(true, 'NO_ALERT');
      return;
    }

    const { showTag, updateType } = this._isShowAlert(strategyConf);

    if (!showTag) {
      cb && cb(true, 'NO_ALERT');
      return;
    }

    if (updateType === 'All') {
      setLocalStorage(EFO_CONF, {
        ...strategyConf,
        date: this._getDate(),
        currentNum: 1,
      })
    } else if (updateType === 'Num') {
      setLocalStorage(EFO_CONF, {
        ...strategyConf,
        currentNum: strategyConf.currentNum + 1
      })
    }

    this._showAlert(arrived_time, showLogInfo, cb)
  }

  setStrategyInfo(param) {
    if (this._isUpdateStrategy(param?.uniqueId)) {
      const {cycle, num, uniqueId} = param
      setLocalStorage(EFO_CONF, {
        cycle, //周期（天）
        num, // 一个周期最多几次
        uniqueId, // 唯一id
        date: this._getDate(), // 当前日期
        currentNum: 0, // 当前次数
      })
    }
  }

  _isShowAlert(strategyConf) {
    const { cycle, num, date, currentNum } = strategyConf;
    const betweenDay = this._daysBetween(date); // 差几天

    if ( betweenDay+1 > cycle) { // 日期超过策略周期，弹窗并全部重置日期和次数
      return {
        showTag: true, 
        updateType: 'All'
      }
    }

    if (currentNum < num) {  // 次数没有超过 则 弹窗 并更新次数
      return {
        showTag: true,
        updateType: 'Num'
      }
    }

    return { showTag: false }
  }

  _showAlert(arrived_time, showLogInfo, cb) {
    const {
      content, title, confirmButtonText, cancelButtonText
    } = this._getAlertInfo(arrived_time);

    NewAlert.confirm(
      content,
      title,
      {
        confirmButtonText,
        cancelButtonText,
        showClose: false,
        center: true,
        customClass: 'sailing_fe_new_alert',
      }
    )
    .then(() => { cb & cb(false) })
    .catch(() => { cb & cb(true) });

    if (showLogInfo && showLogInfo?.eventId) {
      trackEvent(showLogInfo);
    }
  }

  _getAlertInfo(arrived_time) {
    const content  = arrived_time ? i18n.t('FoodC_dish_Current_activity_Iyrv', {arrived_time}) : i18n.t('FoodC_dish_You_will_AXAT');
    const title = i18n.t('FoodC_dish_Are_you_TaUN');
    const confirmButtonText = i18n.t('FoodC_dish_Look_again_fJrp');
    const cancelButtonText = i18n.t('FoodC_dish_Leaving_LwWJ');
    return { content, title, confirmButtonText, cancelButtonText }
  }

  _isUpdateStrategy(uniqueId) {
    const conf = getLocalStorage(EFO_CONF) || {};
    if (uniqueId && uniqueId === conf?.uniqueId) {
      return false
    }

    return true
  }
  
  _getDate() {
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    return `${y}-${m}-${d}`
  }

  _daysBetween(endDate) {
    const time1 = Date.parse(new Date(endDate));
    const time2 = Date.parse(new Date(this._getDate()));
    const nDays = Math.abs(parseInt((time2 - time1)/1000/3600/24));
    return nDays;
  }

}

const efoStrategy = new EfoStrategy();

export default efoStrategy;
